import { gql } from '@apollo/client';

export const UPDATE_USER = gql`
  mutation Flex_UpdateUser($id: Int!, $input: UpdateUserInput!) {
    updateUser(id: $id, input: $input) {
      id
      firstName
      lastName
      email
      phone
    }
  }
`;
